import React, { useState } from "react";
import { MdShoppingCart, MdAdd, MdLogout } from "react-icons/md";
import { motion } from "framer-motion";

import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { app } from "../firebase.config";

import Logo from '../img/logo1.png';
import Avatar from '../img/avatar.png';
import { Link } from "react-router-dom";
import { useStateValue } from "../context/StateProvider";
import { actionType } from "../context/reducer";

const Header = () => {

  const firebaseAuth = getAuth(app);
  const provider = new GoogleAuthProvider();

  const [{ user, cartShow, cartItems }, dispatch] = useStateValue()
  // eslint-disable-next-line
  const [isShoes, setisShoes] = useState(false)

  const login = async () => {
    if (!user) {
      // eslint-disable-next-line
      const { user: { refreshToken, providerData } } = await signInWithPopup(firebaseAuth, provider);
      dispatch({
        type: actionType.SET_USER,
        user: providerData[0],
      });
      localStorage.setItem('user', JSON.stringify(providerData[0]))
    } else {
      setisShoes(!isShoes);
    }
  };

  const logout = () => {
    setisShoes(false)
    localStorage.clear()

    dispatch({
      type: actionType.SET_USER,
      user: null
    });
  };

  const showCart = () => {
    dispatch({
      type: actionType.SET_CART_SHOW,
      cartShow: !cartShow,
    });
  };

  return (
    <header className="fixed z-50 w-screen p-3 px-4 md:p-6 md:px-16 bg-primary">
      {/* desktop & tablet*/}
      <div className="hidden md:flex w-full h-full items-center justify-between">
        <Link to={'/'} className="flex items-center gap-2">
          <img src={Logo} className="w-15 h-12 object-cover" alt="logo" />
          <p className="textheadingColor text-l text-orange-600">UNISHOES</p>
        </Link>

        <div className="flex items-center gap-8">
          <motion.ul
            initial={{ opacity: 0, x: 200 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 200 }}
            className="flex items-center gap-8">
            <Link to={'/'} className="flex items-center gap-2">
              <li className="text-base text-textColor hover:text-headingColor duration-100 
              transition-all ease-in-out cursor-pointer" >
                Home
              </li>
            </Link>


            <li className="text-base text-textColor hover:text-headingColor duration-100 
              transition-all ease-in-out cursor-pointer"
            ><a href="#Shoes">
                Shoes
              </a></li>


            <Link to={'/AboutUs'} className="flex items-center gap-2">
              <li className="text-base text-textColor hover:text-headingColor duration-100 
            transition-all ease-in-out cursor-pointer">
                About Us
              </li>
            </Link>
          </motion.ul>

          <div className="relative flex items-center justify-center" onClick={showCart}>
            <MdShoppingCart className="text-textColor text-2xl cursor-pointer" />
            {cartItems && cartItems.length > 0 && (
              <div className="absolute -top-3.5 -right-2 w-5 h-5 rounded-full bg-cartNumBg flex items-center justify-center">
                <p className="text-xs text-white font-semibold">{cartItems.length}</p>
              </div>
            )}
          </div>

          <div className="relative">
            <motion.img
              whileTap={{ scale: 0.6 }}
              src={user ? user.photoURL : Avatar}
              className="w-10 min-w-[40px] h-10 min-h-[40px] drop-shadow-xl cursor-pointer rounded-full"
              alt="userprofile"
              onClick={login}
            />
            {
              isShoes && (
                <motion.div
                  initial={{ opacity: 0, scale: 0.6 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.6 }}
                  className="w=50 bg-gray-50 shadow-xl rounded-lg flex flex-col absolute top-12 right-0 px-2 py-2">
                  {
                    user && user.email === "johnlouiecampos18@gmail.com" && (
                      <Link to={"/createItem"}>
                        <p className="px-1 py-2 flex items-center gap-3 cursor-pointer  hover:bg-slate-100 
                    transition-all duration-100 ease-in-out text-textColor text-base"
                          onClick={() => setisShoes(false)}
                        >
                          New Item <MdAdd />
                        </p>
                      </Link>
                    )}
                  <p className="px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-100 
                transition-all duration-100 ease-in-out text-textColor text-base"
                    onClick={logout}
                  >
                    Logout <MdLogout />
                  </p>
                </motion.div>
              )
            }
          </div>
        </div>
      </div>

      {/* mobile */}
      <div className="flex items-center justify-between md:hidden w-full h-full">

        <div
          className="relative flex items-center justify-center"
          onClick={showCart}
        >
          <MdShoppingCart className="text-textColor text-2xl cursor-pointer" />
          {cartItems && cartItems.length > 0 && (
            <div className="absolute -top-3.5 -right-2 w-5 h-5 rounded-full bg-cartNumBg flex items-center justify-center">
              <p className="text-xs text-white font-semibold">{cartItems.length}</p>
            </div>
          )}
        </div>

        <Link to={'/'} className="flex items-center gap-2">
          <img src={Logo} className="w-15 h-12 object-cover" alt="logo" />
          <p className="textheadingColor text-l text-orange-600"></p>
        </Link>

        <div className="relative">
          <motion.img
            whileTap={{ scale: 0.6 }}
            src={user ? user.photoURL : Avatar}
            className="w-10 min-w-[40px] h-10 min-h-[40px] drop-shadow-xl cursor-pointer rounded-full"
            alt="userprofile"
            onClick={login}
          />
          {
            isShoes && (
              <motion.div
                initial={{ opacity: 0, scale: 0.6 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.6 }}
                className="w=50 bg-gray-50 shadow-xl rounded-lg flex flex-col absolute top-12 right-0 px-2 py-2">
                {
                  user && user.email === "johnlouiecampos18@gmail.com" && (
                    <Link to={"/createItem"}>
                      <p className="px-1 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-100 
                    transition-all duration-100 ease-in-out text-textColor text-base"
                        onClick={() => setisShoes(false)}
                      >
                        New Item <MdAdd />
                      </p>
                    </Link>
                  )}
                <ul
                  className="flex flex-col">
                  <Link to={'/'} className="flex items-center gap-2">
                    <li className="text-base text-textColor hover:text-headingColor duration-100 
                    transition-all ease-in-out cursor-pointer" >
                      Home
                    </li>
                  </Link>
                  <li className="text-base text-textColor hover:text-headingColor duration-100 
                      transition-all ease-in-out cursor-pointer hover:bg-slate-100 px-4 py-2"
                  ><a href="#Shoes">
                      Shoes
                    </a>
                    Shoes
                  </li>
                  <Link to={'/AboutUs'} className="flex items-center gap-2">
                    <li className="text-base text-textColor hover:text-headingColor duration-100 
                    transition-all ease-in-out cursor-pointer">
                      About Us
                    </li>
                  </Link>
                </ul>
                <p className="m-2 p-3 rounded-md shadow-md flex items-center justify-center bg-gray-200 gap-3 cursor-pointer hover:bg-gray-300 
                transition-all duration-100 ease-in-out text-textColor text-base"
                  onClick={logout}
                >
                  Logout <MdLogout />
                </p>
              </motion.div>
            )
          }
        </div>
      </div>
    </header >
  );
};

export default Header;
